export default __webpack_public_path__ + "51b313899a09215692f05b5843056a65.svg";